import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const CopyIcon = (props: SvgIconProps) => (
  <ContentCopyOutlinedIcon {...props} fontSize="small" />
);

export default CopyIcon;
